import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbField } from "abreact/form/AbField";
import { AbFieldGroup } from "abreact/form/AbFieldGroup";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbTabControl, AbTabControlTheme } from "abreact/incubator/ui/component/AbTabControl";
import { PopupPosition } from "abreact/incubator/ui/popup/PopupPosition";
import { AbTextInput } from "abreact/input/AbTextInput";
import { AbHBox } from "abreact/layout/AbHBox";
import { AbButton } from "abreact/misc/AbButton";
import { AbDialog } from "abreact/popup/AbDialog";
import { makeObservable, observable, runInAction } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
export let AbMarkdownImageDialog = observer(_class = (_class2 = class AbMarkdownImageDialog extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "mode", void 0);
    // is this dialog creating a new image, or editing an existing one?
    _initializerDefineProperty(this, "alt", _descriptor, this);
    _initializerDefineProperty(this, "url", _descriptor2, this);
    _initializerDefineProperty(this, "currentTab", _descriptor3, this);
    _initializerDefineProperty(this, "uploadPath", _descriptor4, this);
    _defineProperty(this, "inputRef", null);
    _defineProperty(this, "onOk", async () => {
      return this.props.onOk(this.alt, this.url);
    });
    _defineProperty(this, "onClose", () => {
      this.props.onClose();
    });
    _defineProperty(this, "urlIsValid", () => {
      try {
        let url = new URL(this.url);
      } catch (e) {
        return false;
      }
      return true;
    });
    makeObservable(this);
    this.mode = this.props.buttonEl ? "create" : "edit";
    this.alt = this.props.alt;
    this.url = this.props.url;
  }
  /**
   * Called when then local browse-for-file dialog is dismissed.
   * Deliberately not AbFileBrowser, because it never looks for server files.
   * @param e - The event that contains the files.
   * @private
   */
  onFileInputChange(e) {
    let files = e.target.files;
    if (!files || files.length !== 1) return;
    const fileToUpload = files[0];
    runInAction(() => {
      this.uploadPath = fileToUpload.name; // display name of file in dialog
    });
    const reader = new FileReader(); // upload the file now, and set the URL as "data:..."
    reader.onload = ev => {
      const result = reader.result;
      if (typeof result === "string") runInAction(() => this.url = reader.result);
    };
    reader.readAsDataURL(fileToUpload);
    e.target.value = ""; // we have to do this, or we don't get called if someone picks the same file
  }
  render() {
    if (this.mode === "create") {
      const tabs = [{
        id: "URL",
        label: "URL",
        content: /*#__PURE__*/React.createElement(AbFieldGroup, null, /*#__PURE__*/React.createElement(AbField, {
          label: AbReactResources.markdownEditor_url(),
          decorators: this.urlIsValid() ? [] : [{
            icon: "absdk:error",
            tooltip: AbReactResources.markdownEditor_urlIsInvalid()
          }],
          singleLine: true,
          fullWidth: true
        }, /*#__PURE__*/React.createElement(AbTextInput, {
          dataTestId: "markdown-link-url",
          value: this.url,
          placeholder: AbReactResources.markdownEditor_urlPlaceholder(),
          onChange: newVal => runInAction(() => this.url = newVal)
        })))
      }, {
        id: "Upload",
        label: "Upload",
        content: /*#__PURE__*/React.createElement(AbHBox, null, /*#__PURE__*/React.createElement(AbTextInput, {
          dataTestId: "markdown-upload-path",
          value: this.uploadPath,
          className: "markdown-upload-path",
          placeholder: AbReactResources.markdownEditor_browseToUploadImage(),
          onChange: newVal => runInAction(() => this.uploadPath = newVal)
        }), /*#__PURE__*/React.createElement(AbButton, {
          icon: "absdk:browse-file-or-path",
          className: "ab-no-border-button",
          onClick: () => {
            if (this.inputRef) this.inputRef.click();
          }
        }), /*#__PURE__*/React.createElement("input", {
          type: "file",
          style: {
            position: "fixed",
            top: "-100em"
          },
          onChange: e => this.onFileInputChange(e),
          accept: "image/*",
          className: "abui",
          ref: ref => this.inputRef = ref
        }))
      }];
      return /*#__PURE__*/React.createElement(AbDialog, {
        origin: this.props.buttonEl,
        position: PopupPosition.BELOW,
        resizable: false,
        closeButton: false,
        cancelButton: true,
        submitButton: AbReactResources.markdownEditor_insert(),
        submitButtonProps: this.urlIsValid() ? undefined : {
          disabled: true
        },
        onSubmit: this.onOk,
        onClose: this.onClose,
        className: "ab-markdown-image-dialog"
      }, /*#__PURE__*/React.createElement(AbTabControl, {
        theme: AbTabControlTheme.PRIMARY,
        tabs: tabs,
        activeTab: this.currentTab,
        onChange: newTab => this.currentTab = newTab.id
      }));
    } else {
      return /*#__PURE__*/React.createElement(AbDialog, {
        title: AbReactResources.markdownEditor_editImageDialogTitle(),
        closeButton: false,
        submitButton: "OK",
        onSubmit: this.onOk,
        submitButtonProps: this.urlIsValid() ? undefined : {
          disabled: true
        },
        cancelButton: true,
        onClose: this.onClose,
        style: {
          width: "500px"
        }
      }, /*#__PURE__*/React.createElement(AbFieldGroup, null, /*#__PURE__*/React.createElement(AbField, {
        label: AbReactResources.markdownEditor_linkText(),
        fullWidth: true
      }, /*#__PURE__*/React.createElement(AbTextInput, {
        dataTestId: "markdown-link-text",
        value: this.alt,
        onChange: newVal => runInAction(() => this.alt = newVal)
      })), /*#__PURE__*/React.createElement(AbField, {
        label: AbReactResources.markdownEditor_url(),
        decorators: this.urlIsValid() ? [] : [{
          icon: "absdk:error",
          tooltip: AbReactResources.markdownEditor_urlIsInvalid()
        }],
        singleLine: true,
        fullWidth: true
      }, /*#__PURE__*/React.createElement(AbTextInput, {
        dataTestId: "markdown-link-url",
        value: this.url,
        placeholder: AbReactResources.markdownEditor_urlPlaceholder(),
        onChange: newVal => runInAction(() => this.url = newVal)
      }))));
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "alt", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "url", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "currentTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "URL";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "uploadPath", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _class2)) || _class;
//# sourceMappingURL=AbMarkdownImageDialog.js.map
